import type { Position } from "./model";

export const positionsEqual = (
  [x1, y1, z1]: Position,
  [x2, y2, z2]: Position,
) => x1 === x2 && y1 === y2 && z1 === z2;

export const positionEmpty = ([x, y]: Position) => x === 0 && y === 0;
